export const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const getDistance = (lat1: number, lon1: number, lat2: number, lon2: number): number => {
  const x: number = 69.1 * (lat2 - lat1);
  const y: number = 69.1 * (lon2 - lon1) * Math.cos(lat1 / 57.3);
  return Math.sqrt(x * x + y * y);
}
